import styles from './styles.module.scss'
import React from 'react';
import { QuestionCircleTwoTone } from '@ant-design/icons';

import { Tooltip, Modal } from 'antd';

interface ButtonQuestionProps {
  title?: string
  className?: string
  content: () => React.ReactNode,
  sizePercentage?: string
}

export const ButtonQuestion = ({
  title = '코드를 확인해보세요',
  className = '',
  content,
  sizePercentage = '160%'
}: ButtonQuestionProps ) => {
    const onClick = (e: React.MouseEvent) => () => {
    e.preventDefault();

    Modal.info({
      title,
      centered: true,
      content: (
        <pre>{content()}</pre>
      ),
      onOk() {},
    });
  }

  return (
    <Tooltip title={title}>
      <button
        className={`${styles.btnQuestion} ${className}`}
        onClick={(e) => onClick(e)()}>
        <QuestionCircleTwoTone style={{ fontSize: sizePercentage }} />
      </button>
    </Tooltip>
  )
}